import { stdObject } from "../data/types/stdObject";
import { colors } from "../data/colors";

export const rowColor = ({
  data,
  index,
  statusCode,
  serviceColor,
}: stdObject) =>
  data[statusCode] === 1
    ? colors.lightOrange
    : data[statusCode] === 2
      ? colors.lightGrey
      : (serviceColor ?? (index % 2 === 0 ? colors.white : colors.lightGrey));
